import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import BetTableJoker20 from "../../casinoComponents/betTableJoker20";
import MyBet from "../../casinoComponents/myBet";
import { Link } from "react-router-dom";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import ViewMoreModal from "../../../components/ViewMoreModal";
import {
  getCasinoGameDetails,
  getMatchExposure,
  getCasinoOpenBets,
} from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import { formatJoker20Nation } from "../../../utils/casinoMyBets";
import Joker20Video from "./Joker20Video";
import Joker20RefResults from "../resultui/resultJoker20/Joker20RefResults";
import "../../../styles/games/joker20.css";


export default function Joker20() {
  const [gameData, setGameData] = useState({});
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "joker20";
  const [tableData, setTableData] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);
  const [showResults, setShowResults] = useState(true);

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "joker20";
    setIframeSrc(`https://stream-s-43.uhdmovies.online/casino-stream?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response || {});
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);

  useEffect(() => {
    const subData = gameData?.data?.data?.sub || [];
    if (Array.isArray(subData) && subData.length > 0) {
      const sorted = [...subData].sort((a, b) => (a.sr || 0) - (b.sr || 0));
      setTableData(sorted);
    }
  }, [gameData?.data?.data?.sub]);

  const handleBetClick = (value, selection, betData, type) => {
    if (!value) return;
    fetchExposure();
    fetchMyBetsData();
  };

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const exposureAmount = parseFloat(item.exposure_amount) || 0;
            if (teamName && exposureAmount !== 0) {
              exposureMap[teamName] = exposureAmount;
              exposureMap[teamName.toLowerCase()] = exposureAmount;
              exposureMap[teamName.trim()] = exposureAmount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [gameData?.data?.data?.mid]);

  const fetchMyBetsData = useCallback(async () => {
    if (!gameName) return;
    try {
      const response = await getCasinoOpenBets(gameName);
      if (response?.success && Array.isArray(response.data)) {
        const formattedBets = response.data.map((bet) => ({
          // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
          description: bet.description ?? bet.game_name ?? bet.gameName,
          userName: bet.username || bet.userName || "-",
          matchedBet: bet.matchedBet || bet.nation || bet.selection || bet.player_name || "-",
          selection: bet.selection || bet.player_name || bet.matchedBet || "",
          player_name: bet.player_name || "",
          odds: bet.odds ?? bet.userrate ?? "0",
          stake: bet.stake ?? bet.amount ?? "0",
          placeDate: bet.placeDate ?? bet.created_at ?? "-",
          gametype: bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
          type: bet.type || null,
          exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0,
        }));
        setMyBets(formattedBets);
      }
    } catch (error) {
      console.error("Error fetching my bets (open-downline):", error);
    }
  }, [gameName]);

  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString();
    if (matchId) {
      const t = setTimeout(() => fetchExposure(), 2000);
      const exposureInterval = setInterval(fetchExposure, 2000);
      return () => {
        clearTimeout(t);
        clearInterval(exposureInterval);
      };
    }
  }, [gameData?.data?.data?.mid, fetchExposure]);

  useEffect(() => {
    fetchMyBetsData();
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => clearInterval(intervalId);
  }, [fetchMyBetsData]);

  const d = gameData?.data?.data;
  const roundId = d?.mid || "";
  const title = "Teenpatti Joker 20-20";

  return (
    <CasinoTableLayout
      tableClass="teenpatti-joker"
      rightSide={
        <MyBet
          bets={myBets}
          formatNation={formatJoker20Nation}
          onViewMore={() => setShowViewMoreModal(true)}
        />
      }
    >
      <>
        <CasinoHeading name={title} roundId={roundId} />
        <Joker20Video
          gameType={gameName}
          iframeSrc={iframeSrc}
          cards={d?.card}
          timerValue={d?.lt}
          showResults={showResults}
          onToggleResults={() => setShowResults((v) => !v)}
        />
        {d?.mid ? (
          <div className="casino-detail">
            <BetTableJoker20
              data={tableData}
              onBetClick={handleBetClick}
              exposures={exposures}
            >
              <div className="last-result-title">
                <h5>Last Result</h5>{" "}
                <Link to={`/admin/reports/casinoresult/${gameName}`} className="result-more">
                  View All
                </Link>
              </div>{" "}
              <div className={`casino-video-last-results${showResults ? "" : " hide-lr"}`}>
                <Joker20RefResults gameType={gameName} fallbackTitle={title} />
              </div>
            </BetTableJoker20>
          </div>
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
        formatNation={formatJoker20Nation}
      />
    </CasinoTableLayout>
  );
}
